import { DatalayerZone, defineDirective, FieldViewModel, ISoilAnalysis, numericTextSort, utils } from "../omnia"
import { IDataLayerValue } from "../types"
import { SoilAnalysisLayer } from "./soilAnalysisLayer"
import { getAnalysisZoneDescription, SoilAnalysisZone } from "./soilAnalysisZone"

interface IParentEditor {

    valueLabel: string;
    currentZone: DatalayerZone;

    targetField: FieldViewModel;

    onZoneValueChanged(zone: DatalayerZone): void;

}

export class ZoneValue {

    analysis: ISoilAnalysis;
    text: string;

    constructor(public value: IDataLayerValue) {
        this.analysis = value.Data;
        this.text = ZoneValue.getValueText(value);
    }

    private static getValueText(value: IDataLayerValue) {

        if (value) {

            let analysis = <ISoilAnalysis>value.Data;

            if (analysis) {

                let text = getAnalysisZoneDescription(analysis);
                if (text) return text;

            }

            return value.Name;
        }


    }


}

export class ZoneEditCtrl {

    static create(): ng.IDirective {

        return defineDirective(ZoneEditCtrl, "app/soil/map/zoneEdit.html", {
            parent: "="
        })

    }

    static $inject = ["$scope"];

    private parent: IParentEditor;

    private _fieldSoilAnalysis: ZoneValue[];
    private _allSoilAnalysis: ZoneValue[];

    private _showAllAnalysis: boolean;

    private _currentValue: ZoneValue;


    constructor(private $scope: ng.IScope) {
    }

    $onInit() {

        const { $scope } = this

        this.parent = this.parent || <any>{};

        $scope.$watch("vm.currentZone", () => {
            this.updateAfterZoneChanged(true);
            this.updateShowAllFlag();
        });

        $scope.$watch("vm.currentZone.value", () => {
            this.updateAfterZoneChanged(false);
        });

    }

    get currentValue(): ZoneValue {
        return this._currentValue;
    }

    set currentValue(value: ZoneValue) {
        this._currentValue = value;
        if (this.currentZone) {
            this.currentZone.value = (value ? value.value : null);
        }
    }

    get currentZone(): DatalayerZone {
        return this.parent.currentZone;
    }

    get valueLabel(): string {
        return this.parent.valueLabel;
    }

    get fieldSoilAnalysis(): ZoneValue[] {
        return this._fieldSoilAnalysis;
    }

    get showAllAnalysis(): boolean {
        return this._showAllAnalysis;
    }

    set showAllAnalysis(value: boolean) {
        this._showAllAnalysis = value;
        this.updateShowAllFlag();
    }


    get allSoilAnalysis(): ZoneValue[] {
        return this._allSoilAnalysis;
    }

    onZoneValueChanged(zone: DatalayerZone) {
        if (this.parent && this.parent.onZoneValueChanged) {
            this.parent.onZoneValueChanged(zone);
        }
    }

    private updateAfterZoneChanged(zoneChanged: boolean) {

        var zone = <SoilAnalysisZone>this.currentZone;

        if (zoneChanged || (!this._allSoilAnalysis)) {

            this._allSoilAnalysis = [];

            if (zone) {
                var allValues = zone.supportedValues.map(v => new ZoneValue(v));
                this._allSoilAnalysis = numericTextSort(allValues, v => v.text);
            }

        }

        this._fieldSoilAnalysis = null;

        if (zone) {

            let fieldSoilAnalysis = zone.getSupportedValuesForField(true);

            let values = this._allSoilAnalysis.filter(i => !!fieldSoilAnalysis.find(v => v == i.value));
            values = numericTextSort(values, v => v.text);
            this._fieldSoilAnalysis = values;

            this._currentValue = this._allSoilAnalysis.find(i => i.value == zone.value);

        }


    }

    private updateShowAllFlag() {

        var zone = this.currentZone;
        if (zone && zone.layer) {
            var soilAnalysisLayer = <SoilAnalysisLayer>zone.layer;
            soilAnalysisLayer.showAllAnalysis = this._showAllAnalysis;
        }

    }

    private filterAnalysis(criteria: string) {

        criteria = utils.regexp.escape(criteria);
        let regex = new RegExp(criteria, "i");

        return (value: ZoneValue) => {
            return regex.test(value.text);
        }

    }

}
